module.exports = "/images/vendor/flag-icon-css/flags/1x1/sl.svg?f6315f743d7d62adc0f130ec0b4d13a5";